<!--header-right-->
<template>
  <div class="home-business-card-child">
    <div class="departure" @click="$emit('clickLeft')">
      <div class="text" v-if="title">
        <div class="text-content">
          <span>{{title}}</span>
          <div v-if="subTitle1" class="subTitle">{{subTitle1}}</div>
        </div>
      </div>
      <span v-else class="gray">{{placeholder1}}</span>
      <span
          v-if="showLogo"
          class="clear"
          :type="logoName"
          @click.stop="$emit('right')"
          :style="{backgroundImage: `url(${require('@/assets/image/base/cell/' + logoName)})`}"
      ></span>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import HsButton from "@/base/hs-button/hs-button.vue";
import HsTab2 from "@/base/hs-tab/hs-tab-2.vue";
import HsTab4 from "@/base/hs-tab/hs-tab-4.vue";
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle1: {
      type: String,
      default: ''
    },
    placeholder1: {
      type: String,
      default: ''
    },
    showLogo: {
      type: Boolean,
      default: false
    },
    logoName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedIndex: 0,
      tabList: [this.$t('FlightTicket'), this.$t('Hotel')]
    }
  },
  methods: {
    _selectTab() {

    },
  },
  components: {
    HsTab2,
    HsTab4,
    HsButton
  },
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
$height = 56px
/** 超标支付样式  */
.home-business-card-child
  width 100%
  min-height $height
  box-shadow 0px -0.5px 0px 0px $color_black_30 inset
  padding 18px 0
  &:last-child
    box-shadow none
  >.departure, >.arrive
    @extend .flex-between
    @extend .hs-font-subtitle-big
    width 100%
    color $color_black_800
    >.text
      @extend .flex-start
      align-items baseline
      span{
        font-weight bold
      }
      >.des
        @extend .hs-font-caption-1
        ellipsis(1)
        color $color_black_100
        margin-left 2px
    >.gray
      @extend .hs-font-body-note-1
      width 100%
      color $color_black_50
    >.clear
      flex-shrink 0
      width 16px
      height 16px
      background-size 100% 100%
      background-position no-repeat
      margin-left 12px
      &[type='icons_24pt_close.svg']{
        width 24px
        height 24px
      }
  >.arrive
    @extend .flex-end
</style>
